<template>

<div class="main content-pages-detailz detail-viewz" v-if="!loading">
	<div>
		<label>Description</label>
		<input type="text" v-model="page.description">
		<div class="two-columns">
			<div>
				<label>Page Type</label>
				<select v-model="page.page_type_id">
					<option value="">Select Page Type...</option>
					<option v-for="(pageType, index) in pageTypeIDList" :value="pageType.page_type_id">{{ pageType.description }}</option>
				</select>
			</div>
			<div class="form-quarter control-group">
				<label class="dark-font radio first">
					<input type="radio" v-model="page.internal_use_only" value="0">
					<span class="published"><i class="fas fa-check-circle"></i>Published</span>
				</label>
				<label class="dark-font radio last">
					<input type="radio" v-model="page.internal_use_only" value="1">
					<span class="unpublished"><i class="fas fa-check-circle"></i>Unpublished</span>
				</label>
			</div>
		</div>

	</div>

	<div>
		<ckeditor :editor="editor" v-model="page.content" :config="editorConfig"></ckeditor>
	</div>

	<label class="calendar-embed-source-label" for="calendar_embed_source" v-if="pageTypeIDList[page.page_type_id] && pageTypeIDList[page.page_type_id].page_type_code == 'GOOGLE_CALENDAR'">Calendar Embed Source
		<input id="calendar_embed_source" type="text" v-model="page.script_identifier">
	</label>

	<label class="jotform-embed-source-label" for="jotform_embed_source" v-if="pageTypeIDList[page.page_type_id] && pageTypeIDList[page.page_type_id].page_type_code == 'JOTFORM'">JotForm Link (Hint: should look something like: https://form.jotform.com/xxxxxxxxxx, where the x's are numbers)
		<input id="jotform_embed_source" type="text" v-model="page.script_identifier">
	</label>

	<div v-if="!loading" class="controls detail-controls">
		<router-link tag="button" to="/website/content-pages" class="button neutral spaced" v-if="!contentChanged"><span>Back to List</span></router-link>
		<router-link tag="button" to="/website/content-pages" class="button cancel spaced" v-else>Cancel Edit</router-link>
		<button class="button action" @click="saveContent"><span>Save This Page</span></button>
        <div v-if="saving" class="message"><i class="fas fa-spinner fa-spin"></i></div>
		<div v-if="message" class="message">{{ message }}</div>
	</div>

</div>

<loading class="full-page" v-else>
    Loading...<br>
</loading>

</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import List from '@ckeditor/ckeditor5-list/src/list';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import { Undo, Redo } from '@ckeditor/ckeditor5-undo/src/';

import CDSUploadAdapter from '@/modules/website/components/contentpagesuploadadapter.js';

export default {
	name: '',
	props: ['id'],
    components: {
        'ckeditor': CKEditor.component
    },
	data() {
		return {
			loading: true,
            message: '',
			editor: ClassicEditor,
			editorConfig: {
                plugins: [
					Alignment,
					Image,
					ImageToolbar,
					ImageCaption,
					ImageStyle,
					ImageResize,
					ImageUpload,
                    Bold,
                    Italic,
					Underline,
                    Link,
                    Paragraph,
					Heading,
					List,
					MediaEmbed,
					Undo,
					// Redo
                ],

                toolbar: {
                    items: [
                        'bold',
                        'italic',
						'underline',
						'heading',
						'link',
						'alignment:left',
						'alignment:center',
						'alignment:right',
						'numberedList',
						'bulletedList',
						'imageUpload',
						'mediaEmbed',
                        'undo',
                        'redo',
                    ]
                },
				extraPlugins: [ this.theUploadAdapterPlugin ],
				heading: {
		            options: [
		                { model: 'paragraph', title: 'Paragraph' },
		                { model: 'heading1', view: 'h1', title: 'Heading 1' },
						{ model: 'heading2', view: 'h2', title: 'Heading 2' },
		                { model: 'heading3', view: 'h3', title: 'Heading 3' },
					]
				},
				image: {
		            // You need to configure the image toolbar, too, so it uses the new style buttons.
		            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
		            styles: [
		                // This option is equal to a situation where no style is applied.
		                'full',

		                // This represents an image aligned to the left.
		                'alignLeft',

		                // This represents an image aligned to the right.
		                'alignRight'
		            ]
		        },
				mediaEmbed: {
					removeProviders: [ 'dailymotion', 'spotify', 'instagram', 'twitter', 'googleMaps', 'flickr', 'facebook' ] // 'vimeo', 
				}
            },
			page: {
				page_id: null,
				content: '',
				page_type_id: '',
				description: null,
				link_name: null,
				script_identifier: null,
				internal_use_only: 0,
				sort_order: 0
			},
			pageCopy: '',
			pageTypeIDList: [],
			cancel: false,
			saving: false
		}
	},
	mounted() {
    	// this.fetchData()
	},
	beforeDestroy() {
	},
	created() {
		if (this.id) {
			this.fetchData()
		}
	},
	computed: {
		contentChanged() {
			if (this.page.internal_use_only != this.pageCopy.internal_use_only) return true
			if (this.$changed(this.page, this.pageCopy)) return true
			return false
		}
	},
	methods: {
		fetchData() {
			this.loading = true
			this.apiCall({ destination: 'get_item_page', data: { page_id: this.id } }).then(obj => {
				this.loading = false
				if (obj.page) {
					this.page = obj.page
					this.pageCopy = this.$copy(obj.page)
				}
				this.pageTypeIDList = obj.page_type_id_list
			}).catch(err => {
				console.log(err)
			})
		},
		theUploadAdapterPlugin(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
				return new CDSUploadAdapter(loader);
			}
		},
		saveContent() {
			this.saving = true
            this.message = ''
			this.apiCall({ destination: 'save_item_page', data: this.page }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					if (this.id == 'new') {
						this.$router.push('/website/content-pages/' + obj.page_id)
					} else {
						this.page.link_name = obj.link_name
						this.pageCopy = this.$copy(this.page)
					}
				} else {
                    this.message = obj.message
                }
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>
